import * as React from 'react';
import { useEffect, useState } from 'react';
import ChatMessages from '../../../../services/dataKeepers/ChatMessages';
import { Transition } from 'react-transition-group';
import capitalize from '../../../../services/mini/capitalize';
import { DEFAULT_INTERIM_MESSAGE } from '../../../../../../alan_btn/src/textChat/helpers/getMsgLoader';

export function MessageProgress({ message }) {
    const statuses = message.queryProgress || [];
    const updateTs = message.queryProgressUpdateTs || 0;

    const newStatuses = message?.queryProgress?.filter(s => s.isShown === false);

    let initStatus = DEFAULT_INTERIM_MESSAGE;
    if (newStatuses?.length > 0) {
        initStatus = newStatuses[0].text;
    } else if (message?.queryProgress?.length > 0) {
        initStatus = message?.queryProgress[message?.queryProgress?.length - 1].text;
    }

    const [status, setStatus] = useState(initStatus);

    useEffect(() => {
        const intervalId = setInterval(() => {
            const newStatus = ChatMessages.updateMessageStatus(message);
            if (newStatus) {
                setStatus(newStatus);
            }
        }, 300);

        return () => clearInterval(intervalId);
    }, [updateTs, statuses, message]);

    const duration = 700,
        timeout = {
            appear: duration,
            enter: duration,
            exit: duration,
        },
        defaultStyle = {
            transition: `opacity ${duration}ms ease-in-out`,
            opacity: 0,
            display: 'flex',
            alignItems: 'center',
            maxWidth: '100%'
        },
        transitionStyles = {
            entering: { opacity: 1 },
            entered: { opacity: 1 },
            exiting: { opacity: 1 },
            exited: { opacity: 0 },
        };

    return (
        <Transition
            in={true}
            appear={true}
            timeout={timeout}
            key={status}
        >
            {(state) => (
                <div style={{
                    ...defaultStyle,
                    ...transitionStyles[state]
                }}>
                    <div className="message-progress">
                        {capitalize(status)}
                    </div>
                </div>)}
        </Transition>
    )
}